import * as DialogPrimitive from '@radix-ui/react-dialog';

export const PvDialogTrigger = DialogPrimitive.Trigger;
